import React, {Component} from "react";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import CodeBlock from "../../../common/CodeBlock";
import {Link} from "react-router";
import {currentSiteName} from "../../../service/SiteService";

class Simple extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Simple mocks (beginner)</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>Use {currentSiteName} API mocks to:</p>
                                <ul>
                                    <li>run standalone mocks in place of real systems</li>
                                    <li>turn an OpenAPI file into a mock API for testing or QA</li>
                                    <li>quickly set up a temporary API for your mobile/web client teams whilst the real API is being built</li>
                                    <li>decouple your integration tests from the cloud/various back-end systems and take control of your dependencies</li>
                                </ul>

                                <h3>Basic example</h3>
                                <p>
                                    To get started, you can upload a valid <i>OpenAPI</i> specification file in
                                    YAML or JSON format.
                                </p>

                                {/* Examples */}
                                <div className="callout m-t-sm">
                                    <div className="callout-content">
                                        For examples, see the official OpenAPI repository.
                                    </div>
                                    <div className="callout-secondary">
                                        <Link href="https://github.com/OAI/OpenAPI-Specification/tree/master/examples/v2.0/yaml" className="btn btn-sm btn-info"
                                              target="_blank">View examples</Link>
                                    </div>
                                </div>

                                <p>Here's a basic example:</p>
                                <CodeBlock code={`---
  swagger: "2.0"
  info:
    version: "1.0.0"
    title: "Petstore"
  consumes:
    - "application/json"
  produces:
    - "application/json"
  paths:
    /pets:
      get:
        description: "Returns all pets from the system that the user has access to"
        produces:
          - "application/json"
        responses:
          "200":
            description: "A list of pets."
            schema:
              type: "array"
              items:
                $ref: "#/definitions/Pet"
            examples:
              application/json: |-
                [
                  {
                    "id": 101,
                    "name": "Cat"
                  },
                  {
                    "id": 102,
                    "name": "Dog"
                  }
                ]
  definitions:
    Pet:
      type: "object"
      required:
        - "id"
        - "name"
      properties:
        id:
          type: "integer"
          format: "int64"
        name:
          type: "string"
`}/>

                                <h3>Testing your mock</h3>
                                <p>Using the specification above, when you make an HTTP GET request to the <code>/pets</code> endpoint, the example data
                                will be returned:</p>
                                <CodeBlock code={`HTTP GET https://live.mocks.cloud/some-id/pets
...
200 OK
...
[
  {
    "id": 101,
    "name": "Cat"
  },
  {
    "id": 102,
    "name": "Dog"
  }
]
`}/>

                                <p>You can add as many endpoints and operations as you like, in line with the OpenAPI
                                specification.</p>

                                <p>
                                    <em>Note:</em> It's important to populate the <code>examples</code> section,
                                    if you want to get useful results when calling your mocks.
                                </p>

                                {/* Learn more */}
                                <div className="callout m-t-sm">
                                    <div className="callout-content">
                                        Learn more about the OpenAPI specification.
                                    </div>
                                    <div className="callout-secondary">
                                        <Link href="https://www.openapis.org/" className="btn btn-sm btn-info"
                                              target="_blank">Learn more</Link>
                                    </div>
                                </div>

                                <hr/>
                                <h2>Scripted responses (advanced)</h2>
                                <p>For more advanced scenarios, you can also control {currentSiteName}'s responses using JavaScript
                                    or Groovy scripts.</p>

                                <Link to="/docs/mocks/advanced" className="btn btn-info">Show advanced configuration</Link>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Simple;



// WEBPACK FOOTER //
// ./src/modules/views/docs/mocks/Simple.js